import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "f-ui-document" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "label" }

import {Download01, File06} from "utruckin-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'documentMessage',
  props: {
    documentUrl: {},
    caption: {}
  },
  setup(__props: any) {

const props = __props

const handleClick = (event: any) => {
  event.stopPropagation()
  window.open(props.documentUrl, "_blank");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "icon",
        onClick: _cache[0] || (_cache[0] = (e) => {handleClick(e)})
      }, [
        _createVNode(_unref(File06), { size: 16 })
      ]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.caption), 1)
    ]),
    _createElementVNode("div", {
      class: "action",
      onClick: _cache[1] || (_cache[1] = (e) => {handleClick(e)})
    }, [
      _createVNode(_unref(Download01), { size: 16 })
    ])
  ]))
}
}

})